module.exports = __webpack_public_path__ + "img/ibid_automotive_slider.2e42d4fb.jpg";